export default {
      id: "file-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "icons.svg#file",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/file.svg
// module id = 286
// module chunks = 0